import { BaseService } from '@services/BaseService'

const resource = 'hr/medicalvisit'

class MedicalVisitService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const medicalVisitService = new MedicalVisitService()
